import Home from "../../components/Landing/Home";

function PatientHome({setSearchText}) {
  return <Home type="patient" setSearchText={setSearchText}/>;
}
export default PatientHome;
